// extracted by mini-css-extract-plugin
export default {"statCard":"dash_statCard__hAcu3"};